/**
 * Created by user on 2020/5/29.
 */

import table_tw2cn from './table_tw2cn.json'
import { ITable } from '../types';

export = table_tw2cn as ITable
